import React from "react";
import {
  Box,
  Flex,
  Image,
  Heading,
  Text,
  VStack,
  useBreakpointValue,
} from "@chakra-ui/react";
import { Socials } from "../../Components";

const ReachMe = () => {
  // Define responsive padding for the Flex container
  const pxValue = useBreakpointValue({ base: 4, md: 12, lg: 24 });

  return (
    <Box id="contact" mt="100px">
      <Box mb={24} textAlign={{ base: "center", md: "left" }}>
        <Heading mb={4}>Want to link up?</Heading>
        <Text fontSize={{ base: "md", md: "lg", lg: "xl" }}>
          Let's discuss further and turn your dream design into a reality!!!
        </Text>
      </Box>
      <Flex
        direction={{ base: "column", md: "row" }}
        align="center"
        px={pxValue}
        gap={8}
      >
        {/* Left Side: Image */}
        <Box flex="0 0 50%" textAlign="center">
          <Image
            src="sharon.png"
            boxSize={{ base: "300px", md: "450px", lg: "450px" }}
            // objectFit="cover"
          />
        </Box>

        {/* Right Side: Name, Role, and Socials */}
        <VStack
          align={{ base: "center", md: "flex-start" }}
          spacing={4}
          flex="1"
        >
          <Heading textAlign={{ base: "center", md: "left" }}>
            Sharon Nyambura
          </Heading>
          <Text as="p" fontSize={{ base: "md", md: "lg", lg: "1.4rem" }}>
            UI/UX Designer
          </Text>
          <Socials />
        </VStack>
      </Flex>
    </Box>
  );
};

export default ReachMe;
